import LFCDialogTitle from '_components/feedback/LFCDialogTitle';
import {useTranslation} from 'react-i18next';

import {Dialog, DialogContent, Divider} from '@mui/material';

import {HeaderPanel} from './HeaderPanel';
import {MapResultPanel} from './MapResultPanel';

/**
 * 引数
 */
interface Props {
  open: boolean;
  onClose: () => void;
  uuid: string;
}

export const DetailDialog = ({open, onClose, uuid}: Props) => {
  const {t} = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth>
      <LFCDialogTitle onClose={onClose}>{t('詳細')}</LFCDialogTitle>
      <DialogContent>
        <HeaderPanel uuid={uuid} />
        <Divider sx={{margin: '0.5em 0'}} />
        <MapResultPanel uuid={uuid} />
      </DialogContent>
    </Dialog>
  );
};
